import React from 'react';
import titleCase from '@/utils/titleCase';
import ActiveSiteIconLabel from './ActiveSiteIconLabel';

export default function Header(props) {
  const { site } = props;

  return (
    <div className="flex flex-col space-y-2">
      <div className="space-y-0.5 w-full">
        <div className="flex items-center justify-between">
          <div className="text-lg font-semibold text-cs-gray-900">
            {site.data.name}
          </div>
          <ActiveSiteIconLabel site={site} />
        </div>
        <div className="text-base text-cs-gray-500 line-clamp-3">
          {titleCase(site.data.addressLine1)}, {titleCase(site.data.city)}, {site.data.state}
        </div>
      </div>
    </div>
  );
}
